<template>
  <nav
    class="hidden bg-white z-50 w-full h-[80px] shadow-md sm:grid place-items-center"
  >
    <div
      class="w-11/12 max-w-screen-xl 4xl:max-w-screen-3xl flex gap-10 items-center content-between mx-auto"
    >
      <div class="flex items-end gap-4">
        <router-link :to="{ name: 'publicPositions' }">
          <img src="/images/logo.svg" alt="logo" class="h-10" />
        </router-link>
        <p
          v-if="isDevOrStaging"
          class="text-sm text-darkGray-1 font-semibold px-4 py-1"
        >
          OBS! Ej riktig data, endast för utveckling och testning.
        </p>
      </div>
      <div class="flex row-wrap gap-8 items-center ml-auto">
        <router-link
          v-for="item in props.listItems"
          :key="item.name"
          :to="item.link"
          class="flex place-content-center hover:text-blue-1"
        >
          <p>{{ item.name }}</p>
        </router-link>

        <router-link
          :to="{ name: 'publicPositions' }"
          class="flex place-content-center"
        >
          <span
            class="relative inline-flex items-center rounded-md border border-transparent bg-gradient-to-b from-orange-1 to-orange-2 px-4 py-2 font-medium text-white shadow-sm hover:from-orange-2 hover:to-orange-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Sök jobb
          </span>
        </router-link>
      </div>
    </div>
  </nav>
  <div class="grid w-full h-full sm:hidden">
    <nav
      class="grid w-full h-[60px] py-4 px-2 text-darkGray-1 place-content-center fixed z-50 bg-white top-0 left-0 shadow-md"
    >
      <router-link class="m-auto" :to="{ name: 'publicPositions' }">
        <img src="/images/logo.svg" alt="logo" class="h-8" />
      </router-link>
      <i
        class="absolute top-1/2 right-4 transform -translate-y-1/2 fas fa-bars text-blue-1 text-2xl"
        @click="toggleMenu"
        v-if="!isMenuOpen"
      ></i>
      <i
        class="absolute top-1/2 right-4 transform -translate-y-1/2 fas fa-times text-blue-1 text-2xl"
        @click="toggleMenu"
        v-else
      ></i>
    </nav>
    <div
      class="fixed top-[60px] left-0 w-full h-full bg-white z-50 border border-t-blue-3 shadow-md"
      v-if="isMenuOpen"
    >
      <div class="flex flex-col">
        <router-link
          v-for="item in props.listItems"
          :key="item.name"
          :to="item.link"
          @click="toggleMenu"
          class="py-6 px-10 border-b border-b-blue-3 flex place-content-between items-center hover:text-blue-1 focused:text-blue-1"
        >
          <i :class="item.icon"></i>
          <p class="text-xl font-semibold">{{ item.name }}</p>
          <i class="fa-solid fa-arrow-right-long -rotate-45"></i>
        </router-link>
        <router-link
          :to="{ name: 'publicPositions' }"
          class="p-8 flex place-content-center"
          @click="toggleMenu"
        >
          <span
            class="relative inline-flex items-center rounded-md border border-transparent bg-blue-1 px-4 py-2 text-lg font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Sök jobb
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref } from "vue";

const host = window.location.host;
const parts = host.split(".");
const subdomain = parts[0];

const isDevOrStaging =
  subdomain.includes("jobb-dev") || subdomain.includes("jobb-staging");

interface ListItem {
  name: string;
  link: string;
  icon: string;
}

const props = defineProps<{
  listItems: ListItem[];
}>();

const isMenuOpen = ref(false);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};
</script>
